module.exports = __webpack_public_path__ + "static/media/hipercard.fc3e8661.svg";